import React, { useEffect, useState } from 'react';
import styles from './UserProfile.module.scss';
import { Col, Form, Input, Row, Select, Button, Modal, Tooltip } from 'antd';
import { IInfoResult, IState, IUserProfile } from '../../../types/api';

import { ReactComponent as FileCopy } from '../../../assets/icon/file_copy.svg';
import { useNavigate } from 'react-router-dom';
import Api from '../../../api/Api';
import useHomeStore from '../../../store/homeStore';
import useAuthStore from '../../../store/authStore';

const { Option } = Select;

export default function UserDetail(props: {
  close?: () => void;
  downloaderApiKey?: string;
  isKeyValid?: boolean;
  requestApiKey?: () => void;
  subscription: {
    type: string;
    expiredDate: string;
  };
  readOnly: boolean;
  postUpdate?: (values: IUserProfile) => {};
}) {
  const userProfile = useAuthStore((state) => state.userProfile);
  const [form] = Form.useForm();
  const user = useAuthStore((state) => state.user);
  const companySizeList = useHomeStore((state) => state.companySizeList);
  const segmentsList = useHomeStore((state) => state.segmentsList);
  const countryList = useHomeStore((state) => state.countryList);
  const [statesList, setStatesList] = useState<IState[]>([]);
  const [credits, setCredits] = useState(0);
  const [openWarnUser, setOpenWarnUser] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!userProfile) return;

    form.setFieldsValue({
      ...userProfile,
      subscription: props.subscription.type,
      expiredDate: props.subscription.expiredDate,
    });

    setCredits(userProfile.credits ? userProfile.credits : 0);
  }, [userProfile, props.subscription, form]);

  const onFinish = (values: IUserProfile) => {
    if (props.postUpdate) props.postUpdate(values);
    if (props.close) props.close();
  };

  const handleEditCompanyProfile = () => {
    if (userProfile?.companyInfo?.editCompanyUrl) {
      window.open(userProfile?.companyInfo?.editCompanyUrl, '_blank');
    } else if (Api.DhiSupportUrl && Api.SERVER_DOMAIN) {
      window.open(
        `${Api.DhiSupportUrl}/company/?redirecttext=MOOD&redirecturl${Api.SERVER_DOMAIN}`,
        '_blank'
      );
    }
  };

  return (
    <>
      <Modal
        title='User is not associated with a company'
        open={openWarnUser}
        onCancel={() => setOpenWarnUser(false)}
        footer={[
          <Button
            key='close'
            type='default'
            onClick={() => setOpenWarnUser(false)}
          >
            Close
          </Button>,
        ]}
      >
        <p>
          Your email address {user.userName}.com is not associated with a
          company. Please contact customer care mike@dhigroup.com to have your
          user profile associated with a company.
        </p>
      </Modal>
      <Form form={form} onFinish={onFinish} layout='vertical'>
        <Row gutter={16} className={styles.registerItemRow}>
          <Col span={8}>
            <div className={styles.registerTitle}>{'Personal information'}</div>
          </Col>
          <Col span={8}>
            <div className={styles.registerTitle}>{'Business information'}</div>
          </Col>
          <Col span={8} />
        </Row>

        <Row gutter={16} className={styles.registerItemRow}>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='userId'
              label='E-mail'
            >
              <Input
                id='UserProfile-UserId_Input'
                placeholder=''
                disabled={true}
                autoComplete='no'
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='company'
              label='Name'
            >
              <Input
                id='UserProfile-Company_Input'
                placeholder=''
                disabled={true}
                autoComplete='no'
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='companyId'
              label='VAT number'
            >
              <Input
                id='UserProfile-CompanyId_Input'
                placeholder=''
                disabled={true}
                autoComplete='no'
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={4}>
            <Form.Item
              className={styles.registerFormItem}
              name='firstname'
              label='First name'
            >
              <Input
                id='UserProfile-FirstName_Input'
                placeholder=''
                disabled={true}
                autoComplete='no'
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              className={styles.registerFormItem}
              name='lastname'
              label='Last name'
            >
              <Input
                id='UserProfile-LastName_Input'
                placeholder=''
                disabled={true}
                autoComplete='no'
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='city'
              label='City'
            >
              <Input
                id='UserProfile-City_Input'
                placeholder=''
                disabled={true}
                autoComplete='no'
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='sizeId'
              label='Company size'
            >
              <Select
                id='UserProfile-CompanySize_Select'
                showSearch
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                style={{ width: '100%' }}
                disabled={true}
              >
                {companySizeList.map((companySize: IInfoResult) => {
                  return (
                    <Option key={companySize.id} value={companySize.id}>
                      {companySize.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='phone'
              label='Phone'
            >
              <Input
                id='UserProfile-Phone_Input'
                autoComplete='no'
                placeholder=''
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='zipcode'
              label='Zip Code'
            >
              <Input
                id='UserProfile-ZipCode_Input'
                placeholder=''
                disabled={true}
                autoComplete='no'
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='segmentId'
              label='Company segment'
            >
              <Select
                id='UserProfile-CompanySegment_Select'
                showSearch
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                style={{ width: '100%' }}
                disabled={true}
              >
                {segmentsList.map((segmentInfo: IInfoResult) => {
                  return (
                    <Option key={segmentInfo.id} value={segmentInfo.id}>
                      {segmentInfo.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='mobile'
              label='Mobile'
            >
              <Input
                id='UserProfile-Mobile_Input'
                autoComplete='no'
                placeholder=''
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='countryId'
              label='Country'
            >
              <Select
                id='UserProfile-Country_Select'
                showSearch
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                style={{ width: '100%' }}
                disabled={true}
              >
                {countryList.map((country) => {
                  return (
                    <Option key={country.id} value={country.id}>
                      {country.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='subscription'
              label='Subscription plan'
            >
              <Input
                id='UserProfile-Subscription_Input'
                autoComplete='no'
                placeholder=''
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          {!props.readOnly ? (
            <Col span={8}>
              <Form.Item className={styles.registerFormItemButton} label={' '}>
                <a
                  href={userProfile?.editProfileUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ textDecoration: 'none' }}
                >
                  <Button
                    type='primary'
                    id='UserProfile-EditPersonalInformation_Button'
                    className={styles.submitBtn}
                  >
                    Edit personal information
                  </Button>
                </a>
              </Form.Item>
            </Col>
          ) : (
            <Col span={8}></Col>
          )}
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='stateId'
              label='State'
            >
              <Select
                id='UserProfile-State_Select'
                showSearch
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                style={{ width: '100%' }}
                disabled={true}
              >
                {statesList.map((state: IState) => {
                  return (
                    <Option key={state.id} value={state.id}>
                      {state.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='expiredDate'
              label='Subscription expiry date'
            >
              <Input
                id='UserProfile-ExpiredDate_Input'
                autoComplete='no'
                placeholder=''
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}></Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='address1'
              label='Address'
            >
              <Input
                id='UserProfile-Address1_Input'
                autoComplete='no'
                placeholder=''
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8}></Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}></Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='address2'
              label='Address 2'
            >
              <Input
                id='UserProfile-Address2_Input'
                autoComplete='no'
                placeholder=''
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8}></Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}></Col>
          <Col span={8}>
            <Form.Item
              className={styles.registerFormItem}
              name='address3'
              label='Address 3'
            >
              <Input
                id='UserProfile-Address3_Input'
                autoComplete='no'
                placeholder=''
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8}></Col>
        </Row>
        {!props.readOnly && (
          <Row gutter={16} className={styles.registerItemRow}>
            <Col span={8}></Col>
            <Col span={8}>
              <Form.Item label={' '} className={styles.registerFormItemButton}>
                <Button
                  type='primary'
                  className={styles.submitBtn}
                  onClick={handleEditCompanyProfile}
                  id='UserProfile-EditBusinessProfile_Button'
                >
                  Edit Business Profile
                </Button>
              </Form.Item>
            </Col>
            <Col span={8} />
          </Row>
        )}
        {!props.readOnly && (
          <>
            <Row
              gutter={16}
              style={{ marginTop: '20px', marginBottom: '10px' }}
            >
              <Col span={8}></Col>
              <Col span={8}></Col>
              <Col span={8}>
                <div>Credits</div>
                <div>{credits}</div>
              </Col>
            </Row>
            <>
              <Row gutter={16} style={{ marginBottom: '10px' }}>
                <Col span={8}></Col>
                <Col span={8}></Col>
                {props.downloaderApiKey && (
                  <Col span={8}>
                    <div>
                      <div style={{ flexWrap: 'nowrap', display: 'flex' }}>
                        API key
                      </div>
                      <div className={styles.apiKeySection}>
                        <div className={styles.apiKeyBox}>
                          <div
                            id='UserProfile-CopyApiKey_Input'
                            className={styles.apiKey}
                            onClick={() => {
                              navigator.clipboard.writeText(
                                props.downloaderApiKey || ''
                              );
                            }}
                          >
                            <div>
                              <Tooltip
                                placement='topLeft'
                                title={props.downloaderApiKey}
                              >
                                {props.downloaderApiKey}
                              </Tooltip>
                            </div>
                            <FileCopy />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
              <Row gutter={16} style={{ marginBottom: '10px' }}>
                <Col span={8}></Col>
                <Col span={8}></Col>
                <Col span={8}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ paddingRight: '0.5rem' }}>
                      <Button
                        className={styles.requestApiKeyButton}
                        type='primary'
                        htmlType='button'
                        id='UserProfile-RequestApiKey_Button'
                        onClick={(e) => {
                          e.preventDefault();
                          props?.requestApiKey && props.requestApiKey();
                        }}
                      >
                        {props.downloaderApiKey
                          ? 'Renew API key'
                          : 'Request API key'}
                      </Button>
                    </div>
                    <div id='UserProfile-ApiKeyStatus_Text'>
                      Your API key is{' '}
                      {props.isKeyValid ? (
                        <b style={{ color: 'green' }}>valid</b>
                      ) : (
                        <b style={{ color: 'red' }}>expired</b>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          </>
        )}
        {!props.readOnly && (
          <Row gutter={16}>
            <Col span={8}></Col>
            <Col span={8}></Col>
            <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
              <div className={styles.linkContainer}>
                <p className={styles.linkPrefix}>For details, please visit</p>
                <div
                  className={styles.link}
                  onClick={() => {
                    navigate('/api');
                  }}
                >
                  https://metocean-on-demand.com/api
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </>
  );
}
